module.exports = __webpack_public_path__ + "img/footer-game-icons.165ab55e.svg";